import React from 'react'
import { Switch, withRouter, Route } from 'react-router-dom'

import { authorization } from '../../Module/Auth/Auth'
import { PrivateRoute } from '../../Config/Routing/auth'
import Home from '../../Containers/Home'
import RejectedCampaign from '../../Containers/Home/components/pages/RejectedCampaign'
import { PATHS } from 'Config/Routing/paths'
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  homeLayout: {
    padding: '20px 35px',
    background: '#F9F9FF',
    width: '100%',
    minHeight: 'calc(100vh - 72px)',

    [theme.breakpoints.down('sm')]: {
      padding: '10px 16px',
      minHeight: 'calc(100vh - 50px)',
    },
  },
}))

const HomeLayout = ({ children }) => {
  const classes = useStyles()

  return <div className={classes.homeLayout}>{children}</div>
}

const HomeRouter = ({ match }) => {
  return (
    <Switch>
      <Route exact path={match.url}>
        <PrivateRoute isRestricted={!authorization.isClient()}>
          <HomeLayout>
            <Home />
          </HomeLayout>
        </PrivateRoute>
      </Route>
      <Route path={`${match.url}${PATHS.dashboard.rejected}/:campaignId`}>
        <PrivateRoute isRestricted={!authorization.isClient()}>
          <HomeLayout>
            <RejectedCampaign />
          </HomeLayout>
        </PrivateRoute>
      </Route>
    </Switch>
  )
}

export default withRouter(HomeRouter)
